import React from 'react';
import { Globe, Instagram, Facebook, MessageCircle } from 'lucide-react';

export const CHANNELS = {
  livechat: { label: 'Live chat', Icon: Globe, chip: 'bg-sky-50 text-sky-700 border-sky-200', solid: 'bg-sky-500 text-white' },
  whatsapp: { label: 'WhatsApp', Icon: MessageCircle, chip: 'bg-emerald-50 text-emerald-700 border-emerald-200', solid: 'bg-[#25D366] text-white' },
  instagram: { label: 'Instagram', Icon: Instagram, chip: 'bg-pink-50 text-pink-700 border-pink-200', solid: 'bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF] text-white' },
  facebook: { label: 'Facebook', Icon: Facebook, chip: 'bg-blue-50 text-blue-700 border-blue-200', solid: 'bg-[#1877F2] text-white' },
};

export const channelOf = (key) => CHANNELS[key] || CHANNELS.livechat;

/** Small round channel badge (used on avatars) */
export const ChannelDot = ({ channel, size = 11, className = '' }) => {
  const ch = channelOf(channel);
  return <span className={`inline-flex items-center justify-center rounded-full border-2 border-white ${ch.solid} ${className}`} style={{ width: size + 9, height: size + 9 }} title={ch.label} data-testid={`channel-icon-${channel}`}><ch.Icon size={size} /></span>;
};

/** Pill chip with label */
export const ChannelChip = ({ channel, className = '' }) => {
  const ch = channelOf(channel);
  return <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium ${ch.chip} ${className}`} data-testid={`channel-chip-${channel}`}><ch.Icon size={11} />{ch.label}</span>;
};

export const visitorName = (c) => {
  const v = c.visitor || {};
  if (c.contact?.name) return c.contact.name;
  if (v.name) return v.name;
  if (v.username) return `@${v.username}`;
  if (v.email) return v.email;
  if (v.phone) return v.phone;
  if (c.channel === 'instagram') return `Instagram ${(c.external_id || '').slice(-4)}`;
  if (c.channel === 'facebook') return `Facebook ${(c.external_id || '').slice(-4)}`;
  if (c.channel === 'whatsapp') return `+${c.external_id || ''}`;
  return 'Pengunjung';
};
